module.exports = __webpack_public_path__ + "res/img_landing_1.5f198f4a9fb873bedeb9d85b048155df.webp";